import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class EndpointResolverService {

  private endPoints: object = {};
  constructor(private readonly http: HttpClient, private injector: Injector) {
    const ep = localStorage.getItem(environment.storage.apiSurface);
    if (ep) {
      this.endPoints = JSON.parse(ep);
    }
  }

  public load() {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.endpoints.api}/.well-known/end-points`).subscribe((endpoints: any) => {

        this.endPoints = endpoints._links;

        localStorage.setItem(environment.storage.apiSurface, JSON.stringify(endpoints._links));
        localStorage.setItem('version', endpoints.version);

        resolve(true);
      }, (err) => {
        console.log('error loading api surface', err.message);

        /* setTimeout(() => {
          const router = this.router();
          router.navigate(['500'], { queryParams: { err: err.message } });
        }, 500); */

        // resolve(false);
        reject(err);
      });
    });
  }

  private router(): Router {
    return this.injector.get(Router);
  }

  public getUrl(name: string): string {
    const ep = this.endPoints[name];
    if (!ep) {
      return null;
    }
    return ep.href;
  }

  public getUrls() {
    return this.endPoints;
  }

  public getVersion(): string {
    return localStorage.getItem('version');
  }
}
